import React from 'react';
import { useAppSelector } from "../../../../store/hooks";
import { selectCategoryEntities, selectCategoryIds } from "../../../../store/sticker_maker/categoriesSlice";

import TagsMenu, { TagsMenuInterface } from "../../../../componets/Tags/TagsMenu";

import './menu_tags.scss';

const _MenuTags = () => {
  const categories  = useAppSelector(selectCategoryEntities);
  const ids         = useAppSelector(selectCategoryIds);
  const renderItems: TagsMenuInterface['items'] = [];

  categories && ids.forEach((id: any) => {
    const category = categories[id];

    if (category) {
      renderItems.push({
        label: category.name,
        color: category.color,
        key: String(id)
      });
    }
  });

  return (
    <TagsMenu
      className='v-menu-tags'
      paramsKey='category_ids'
      items={renderItems}
    />
  )

}

export default _MenuTags;
